import { Checkbox } from 'antd';
import { CheckboxGroupProps } from 'antd/es/checkbox';
import clsx from 'clsx';
import React from 'react';

import s from './Attachments.module.less';

export const Container: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.container, className)} />
);

export const FilesGroup: React.FC<CheckboxGroupProps<string | number>> = ({ className, ...rest }) => (
  <Checkbox.Group {...rest} className={clsx(s.filesGroup, className)} />
);

export const Item: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...rest }) => (
  <div {...rest} className={clsx(s.item, className)} />
);
